import axios from "../api";

export const PaylistTransactionDataAction = async (
  perPage,
  page,
  status,
  pId,
  startDate,
  endDate,
  search
) => {
  let apiUrl = `/api/paytransaction/paycentraltransaction?page=${page}&pageSize=${perPage}`;

  if (status && status !== "all") {
    apiUrl += `&status=${status}`;
  }

  if (pId && pId !== "all") {
    apiUrl += `&pId=${pId}`;
  }

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  if (search) {
    apiUrl += `&search=${search}`;
  }

  return axios.get(apiUrl);
};

export const exportTransactionPaycentralHistoryAction = (data) => {
  return new Promise((resolve, reject) => {
    let url = "/api/paytransaction/exportpaycentral";
    axios
      .post(url, data, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const getPaycentralTransactionsChartDataAction = ({ startDate, endDate, pId, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/transactions-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (pId) params.append("tenantId", pId);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const getPayCentralCalendarChartDataAction = ({ startDate, endDate, tenantId, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/calender-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (tenantId) params.append("tenantId", tenantId);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};





export const getPaycentralRevenueChartData = ({ startDate, endDate, tenantId, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/revenue-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (tenantId) params.append("tenantId", tenantId);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getPayCentralPaymentMethodChartDataAction = ({ startDate, endDate, tenantId, chartType, websiteId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/payment-method-chart`;
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (tenantId) params.append("tenantId", tenantId);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);
    const queryString = params.toString();
    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const PayCentralgetTopPerformingMerchantsAction = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/paytransaction/getTopPerformingMerchants")
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};




export const getPayCentralTenantAction = async (currentPage, searchValue, pageSize, status, byUser) => {
  let apiUrl = `/api/paytransaction/getpaycentraltenants?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}&status=${status}`;
  if (byUser) {
    apiUrl += `&byUser=${byUser}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getCombinedPaymentMethodChartDataAction = ({
  startDate,
  endDate,
  merchant,
  chartType,
  websiteId,
}) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/getCombinedPaymentMethodChartData`; // ✅ NEW API

    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (merchant) params.append("merchant", merchant);
    if (chartType) params.append("chartType", chartType);
    if (websiteId) params.append("websiteId", websiteId);

    const queryString = params.toString();

    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const getCombinedTransactionsAction = ({
  page,
  pageSize,
  startDate,
  endDate,
  searchValue,
  status,
  amount,
  websiteId,
  currency,
  tenantDb,
  tenantType
}) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/getCombinedTransactions`;

    const params = new URLSearchParams();

    // ✅ PAGINATION
    if (page) params.append("page", page);
    if (pageSize) params.append("pageSize", pageSize);

    // ✅ FILTERS (same as backend)
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (searchValue) params.append("searchValue", searchValue);
    if (status) params.append("status", status);
    if (amount) params.append("amount", amount);
    if (websiteId) params.append("websiteId", websiteId);
    if (currency) params.append("currency", currency);
    if (tenantDb) params.append("tenantDb", tenantDb);
    if (tenantType) params.append("tenantType", tenantType);

    const queryString = params.toString();

    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const getCorporationFeeKPIAction = (params) => {
  return new Promise((resolve, reject) => {
    let url = "/api/paytransaction/getCorporationFeeKPI";

    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const listAllCommonTenants = async (
  currentPage,
  searchValue,
  pageSize,
  status
) => {
  let apiUrl = `/api/paytransaction/listAllCommonTenants?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}`;

  if (status) {
    apiUrl += `&status=${status}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => resolve(response?.data))
      .catch((error) => reject(error));
  });
};


export const getCorporationFeeChartDataAction = ({ startDate, endDate, pId }) => {
  return new Promise((resolve, reject) => {
    let apiUrl = `/api/paytransaction/getCorporationFeeChartData`;

    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (pId) params.append("pId", pId);

    const queryString = params.toString();

    axios
      .get(apiUrl + (queryString ? `?${queryString}` : ""))
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};